import { CSSProperties, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from 'atoms/buttons/Button';
import { useConnectionContext } from 'contexts/connection';
import { tabletAndAbove } from 'style/mediaQuery';

import { Pictures } from '../types';

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: var(--double-unit);
  --img-position: center;
  background:
    linear-gradient(
      to bottom,
      rgba(var(--c-rgb-black), 0) 0%,
      rgba(var(--c-rgb-black), 1) 100%
    ),
    no-repeat center / cover var(--background);

  font-size: var(--fs-landing-title);
  height: 310px;
  @media ${tabletAndAbove} {
    height: 588px;
  }
`;
type FooterAssets = Pictures;
type Props = {
  title: ReactNode;
  assets: FooterAssets;
};
export const Footer = ({ title, assets }: Props) => {
  const { signUp } = useConnectionContext();

  return (
    <Root
      className="text-center"
      style={
        {
          '--background': `image-set(url(${assets.avif}) type('image/avif'), url(${assets.pictureUrl}}) type('image/jpeg'))`,
        } as CSSProperties
      }
    >
      {title}
      <Button color="secondary" size="medium" onClick={signUp}>
        <FormattedMessage
          id="landing.EarlyAccess.Footer.cta"
          defaultMessage="Join our community"
        />
      </Button>
    </Root>
  );
};
